/* eslint-disable @typescript-eslint/no-explicit-any */
import { useItem } from 'shared/dynamic-imports';
import { CustomRating } from 'shared/ui-basics/ui-components/CustomRating';
import styled from 'styled-components';

type Props = {
    attribute: any;
    disabled: boolean;
    link: (id: string) => void;
}

export default function Rating({
    attribute,
    disabled,
    link
}: Props): JSX.Element {

    const { currentItem, modifiedAttribNames } = useItem();
    const currentAttribute = currentItem.attributes.find((item: any) => item.id === attribute.id);
    const attributeName = "ratingValue";

    const updateFunction = (item: any) => {
         link(item.ratingValue);

    }
    return (
        <Wrapper >
            <CustomRating
                object={currentAttribute}
                setObject={updateFunction}
                modifiedAttribNames={modifiedAttribNames}
                attribute={attributeName}
                disabled={disabled}
                color={currentAttribute?.colorCode}
            />
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 8px;
`;